import type { Path } from 'react-router';
import { projectContextSearchParamsUpdater } from '@gonfalon/app-context/projectContextSearchParamsUpdater';
import { readProjectContextFromPath } from '@gonfalon/app-context/readProjectContextFromPath';
import { type ProjectContextSearchParams } from '@gonfalon/app-context/types';
import { disableWithProjectContext } from '@gonfalon/dogfood-flags/dogfood-flags';

export function withProjectContext(overrides: Partial<ProjectContextSearchParams> = {}) {
  return (path: Path) => {
    if (disableWithProjectContext()) {
      return path;
    }
    const context = readProjectContextFromPath(window.location);

    if (!context) {
      return path;
    }

    const searchParams = new URLSearchParams(path.search);

    const nextContext = { ...context, selectedViewKey: context.selectedViewKey ?? undefined };
    if (overrides.environmentKeys !== undefined && overrides.environmentKeys.size > 0) {
      const nextEnvironmentKeys = new Set(context.environmentKeys);
      for (const key of overrides.environmentKeys) {
        if (key !== undefined && key !== '') {
          nextEnvironmentKeys.add(key);
        }
      }
      nextContext.environmentKeys = nextEnvironmentKeys;
    }

    if (overrides.selectedEnvironmentKey !== undefined && overrides.selectedEnvironmentKey !== '') {
      nextContext.selectedEnvironmentKey = overrides.selectedEnvironmentKey;

      if (!context.environmentKeys.has(overrides.selectedEnvironmentKey)) {
        nextContext.environmentKeys.add(overrides.selectedEnvironmentKey);
      }
    }

    if (overrides.selectedViewKey !== undefined && overrides.selectedViewKey !== '') {
      nextContext.selectedViewKey = overrides.selectedViewKey;
    }

    const nextSearchParams = projectContextSearchParamsUpdater(searchParams, nextContext);

    return {
      ...path,
      search: nextSearchParams.toString(),
    };
  };
}
